export const handleStyle = {
  fill: 'var(--toolbar)'
}

export const invisibleStyle = {
  fill: 'transparent'
}
